import { QUERY_CACHE_FLAG } from "@/lib/launchdarkly/flags";
import { scopeFor, ScopeNotReadyError } from "@/queries/scope";

/** The part of the root store this reads. Not `RootStore` itself: every store
 *  imports this file, and the root store imports every store. */
export interface FlagSource {
  featureFlags: { isEnabled(key: string): boolean };
}

/**
 * The scope to cache `slug`'s reads and writes under, or `null` to behave the
 * way the flag-off path does: the flag is off, or the session has not said who
 * is signed in yet, so there is no key to cache under.
 */
export function queryCacheScope(rootStore: FlagSource, slug: string, owner: string) {
  if (!rootStore.featureFlags.isEnabled(QUERY_CACHE_FLAG)) return null;
  try {
    return scopeFor(slug);
  } catch (error) {
    if (!(error instanceof ScopeNotReadyError)) throw error;
    console.warn(`[${owner}] used before the session resolved; not cached`, { slug });
    return null;
  }
}
